import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-three-columns-three-page',
  templateUrl: './courses-grid-style-three-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-three-columns-three-page.component.scss']
})
export class CoursesGridStyleThreeColumnsThreePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
